/**
 * Secret VerifyEmail Controller
 *
 *
 */

function SVerifyEmailController() {}

SVerifyEmailController.prototype = {
  constructor: SVerifyEmailController,

  init: function() {
    this._registerRouteVariables();

    PortalHelper.debugMessage("Secret Verify Email Controller Initialized");
  },

  run: function() {
    this._registerEvents();
    PortalHelper.debugMessage("Secret Verify Email Controller Ran");
  },

  _registerEvents: function() {
    var self = this;
    $("#verify-acct-form").on("submit", function(e) {
      e.preventDefault();

      var validated = $("#verify-acct-form")
        .parsley()
        .validate();
      if (validated) {
        self._verifyEmail();
      }
    });
  },

  _registerRouteVariables: function() {
    var segments = PortalMain.getRouteSegments();

    this.userId = segments[0];
    this.verificationHash = segments[1];
  },

  _verifyEmail: function() {
    PortalHelper.loadingOverlay("#verify-acct-form", true);

    var verifyEmailRequest = new PortalRequest();
    verifyEmailRequest.errorElement = "#verify-acct-form .form-errors";
    verifyEmailRequest.makeRequest(
      "/users/verify-email-and-set-password",
      {
        userId: this.userId,
        hash: this.verificationHash,
        passwd: $("#password").val(),
        confirm: $("#confirm").val(),
        g_recaptcha_response: grecaptcha.getResponse()
      },
      function() {
        PortalHelper.loadingOverlay(".verification-content", false);
        $(".verified").removeClass("hidden");

        setTimeout(function() {
          window.location.href = PortalConfig.portalUrl + "/login/";
        }, 3000);
      },
      function() {
        PortalHelper.loadingOverlay("#verify-acct-form", false);
      }
    );
  }
};
